import { render } from "./SelectServiceForm.vue?vue&type=template&id=6c4eae10&ts=true"
import script from "./SelectServiceForm.ts?vue&type=script&lang=ts&external"
export * from "./SelectServiceForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__